module.exports = __webpack_public_path__ + "static/img/xiandainongyezhan.2034adae.png";